import DatepickerContainer from "../../Componant/FormWidgets/Datepicker";

const Datepicker = () => {
  return (
    <div className="page-body">
      <DatepickerContainer />
    </div>
  );
};

export default Datepicker;
